import React from 'react'
import moment from 'moment-timezone'
import * as _style from './NFLTeamAnalysisGameResults.scss'
import CloudinaryImage from '../../../Cloudinary/CloudinaryImage'
import { img } from '@severed-links/common.redherrings-constants'

const opponentAvatar = mascot => mascot ? `/football/nfl-team-small-avatars/${(mascot || '').toLowerCase()}` : img.FootballBlankHelmet

const ResultCard = ({ x, seasonName, suffix = '' }) => (
    <div className={_style.resultCard}>
        <div className={_style.dateRail}>
            <div className={_style.homeAway + ' ' + (x.isHome ? _style.home : _style.away)}>{x.isHome ? 'H' : 'A'}</div>
            <div className={_style.weekLabel}>Week {x.week}</div>
            <div className={_style.dateLabel}>{moment(x.gameDate).local().format('MMM D')}</div>
        </div>
        <div className={_style.logo}>
            <CloudinaryImage publicId={opponentAvatar(x.oppMascot)} />
        </div>
        <div className={_style.opponent}>
            <div className={_style.opponentName}>{x.oppName}</div>
            {x.miniHeader ? <div className={_style.meta}>{x.miniHeader}</div> : null}
        </div>
        <div className={_style.results}>
            <div className={_style.scorePill + ' ' + _style[(x.resultAbbreviation || '').toLowerCase()]}>
                {x.result ? <span>{x.result}, </span> : null}{x.scoreString}
            </div>
            <div className={_style.chipRow}>
                {x.isCover || x.isNotCover || x.isPush ?
                <div className={_style.coverPill + ' ' + _style[x.isCover ? 'cover' : x.isPush ? 'push' : 'noCover']}>
                    {x.spreadResult} <span dangerouslySetInnerHTML={{ __html: x.displayLine }} />
                </div>
                : null}
            </div>
        </div>
    </div>
)

const NFLTeamAnalysisGameResults = ({ seasonName = '', games = [], playoffGames = [] }) => {

    return (
            <div className={_style.container}>
                <div className={_style.sectionHeader}>
                    <h4>Regular season</h4>
                    <div>{games.length} games</div>
                </div>
                <div className={_style.resultsList}>
                {games && games.map(x =>
                    <ResultCard x={x} seasonName={seasonName}
                        key={`nfl-team-analysis-season-result-${x.teamId}-${seasonName}-${x.seasonMode}-week-${x.week}-${x.oppId}`} />
                )}
                </div>
                {playoffGames && playoffGames.length > 0 ?
                <>
                    <div className={_style.sectionHeader + ' ' + _style.postseasonHeader}>
                        <h4>Postseason</h4>
                        <div>{playoffGames.length} games</div>
                    </div>
                    <div className={_style.resultsList}>
                    {playoffGames.map(x =>
                        <ResultCard x={x} seasonName={seasonName}
                            key={`nfl-team-analysis-postseason-result-${x.teamId}-${seasonName}-${x.seasonMode}-week-${x.week}-${x.oppId}`} />
                    )}
                    </div>
                </>
                : null}
            </div>
    )
}

export default NFLTeamAnalysisGameResults
